import { generate } from "../../helpers/element/generate-element";
import { slideDown } from "../../helpers/utils/slide";

class CalculatorBoards {
    constructor() {
        // Discount configuration
        this.discount = {
            percentage: 15, // Discount percentage (e.g., 15 for 15% off)
            startDate: '2025-11-18 00:01:00', // Start date with time
            endDate: '2025-12-06 23:59:59' // End date with time
        };

        this.requiredInputs = [
            'length',
            'thickness',
            'end_banding',
            'rips',
            'dressing',
            'finish',
            'quantity'
        ];

        this.inputGroups = [];
        this.values = [];
        this.costValue;
        this.hasDisplayed = false;

        this.defaultVariables = {
            base_price: 4.5,
            finish_colour: 11.5,
            finish_outdoorDark: 11.5,
            finish_outdoorMedium: 11.5,
            finish_outdoorLight: 11.5,
            finish_outdoorClear: 10.5,
            finish_indoorDark: 11.5,
            finish_indoorMedium: 11.5,
            finish_indoorLight: 11.5,
            finish_indoorClear: 10.5,
            finish_smooth: 4.5,
            finish_raw: 0,
            finish_handling_yes: 5,
            finish_handling_no: 0
        };

        if (this.canInit()) {
            this.getInputs();
            this.addEvents();
        }
    }

    canInit() {
        return document.querySelector('.js-calc-form[data-form=boards]') !== null;
    }

    getInputs() {
        const inputGroups = document.querySelectorAll('.js-calc-form .af-field');

        this.inputGroups = [...inputGroups].filter((group) => {
            return this.requiredInputs.includes(group.dataset.name);
        });
    }

    addEvents() {
        const trigger = document.querySelector('.js-calculate.button');

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleClick();
        });
    }

    handleClick() {
        this.getVariableValues();
        this.getInputValues();
        this.doCalculation();
        this.displayValues();
    }

    getVariableValues() {
        let definedVariables = {};

        if (typeof values_data !== 'undefined' && values_data !== null) {
            definedVariables = values_data;
        }

        this.variables = { ...this.defaultVariables, ...definedVariables };
    }

    getInputValues() {
        this.inputGroups.forEach((inputGroup) => {
            const name = inputGroup.dataset.name;
            const input = inputGroup.querySelector('input');
            const select = inputGroup.querySelector('select');
            let value;

            if (input !== null) {
                value = input.value;
            }

            if (select !== null) {
                value = select.options[select.selectedIndex].value;
            }

            this.values['_' + name] = value;
        });
    }

    doCalculation() {
        const length = parseInt(this.values._length, 10);
        const basePrice = this.variables.base_price * (length / 1000);
        const finish = this.getFinishValue();
        if (finish === null) {
            this.costValue = null;
            return;
        }
        const quantity = parseInt(this.values._quantity, 10);
        const finishCost = finish * (length / 1000);
        const handlingFinish = this.values._finish !== "raw" ? this.variables.finish_handling_yes : this.variables.finish_handling_no;
        const price = basePrice + finishCost;
        const totalPrice = (price * quantity) + handlingFinish;

        this.costValue = totalPrice.toFixed(2);
    }

    getFinishValue() {
        let value = this.variables['finish_' + this.values._finish];
        if (typeof value == 'undefined') {
            return null;
        }
        return value;
    }

    displayValues() {
        const container = document.querySelector('.calc-form-sum__calculated');
        const submitButtons = document.querySelector('.af-submit');
        const costArea = document.querySelector('.calc-form-sum__cost');

        let error = false;
        if (this.costValue === "NaN") {
            error = `Please enter all values`;
        } else if (this.costValue === null) {
            error = `There's been an error with the calculator`;
        }

        if (error) {
            container.classList.add('has-error');
            const costElem = generate('span', error, []);
            costArea.classList.add('is-hidden');

            setTimeout(() => {
                costArea.innerHTML = '';
                costArea.appendChild(costElem);
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                }, 300);
            }

            if (this.hasDisplayed) {
                slideUp(submitButtons, 300);
                this.hasDisplayed = false;
            }
        } else {
            container.classList.remove('has-error');
            costArea.classList.add('is-hidden');

            let priceHtml;
            if (this.isDiscountActive()) {
                const originalPrice = parseFloat(this.costValue);
                const discountedPrice = this.round(originalPrice * (1 - this.discount.percentage / 100), 2);
                priceHtml = `
                    <div class="price-display">
                        <span class="original-price">£${this.costValue}</span>
                        <span class="discounted-price">£${discountedPrice.toFixed(2)}</span>
                    </div>
                `;
            } else {
                priceHtml = `£${this.costValue}`;
            }

            setTimeout(() => {
                costArea.innerHTML = priceHtml;
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(submitButtons, 300, 'flex');
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                    this.hasDisplayed = true;
                }, 300);
            }
        }
    }

    isDiscountActive() {
        const currentDate = new Date();
        const startDate = new Date(this.discount.startDate.replace(' ', 'T'));
        const endDate = new Date(this.discount.endDate.replace(' ', 'T'));
        
        return currentDate >= startDate && currentDate <= endDate;
    }

    round(num, decimals) {
        return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
    }
}

export const calculatorBoards = () => {
    new CalculatorBoards(); // eslint-disable-line no-new
};
